import Vuex from 'vuex'
import { getTypes, getModule, getStore } from '../utils/storeUtil'
import { getter, mutation, action } from '../utils/vuexUtil'
import api from 'api'
import storage from 'src/unit/storage'
import router from '../../router'


export const storeName = 'user'

// /*** state ***/
let state = {
    permission: storage.get('permission') || [],
    userMsg: storage.get('userMsg'),
    token: storage.get('token') || '',
    isLoading: false
}

// /*** getters ***/
let getters = getter(state, {

})

// /*** mutations ***/
let mutations = mutation(state, {
    setUserMsg(state, data) {
        state.userMsg = data
        state.token = data.token
        state.permission = data.permission
        storage.set('userMsg', data)
        storage.set('token', data.token)
        storage.set('permission', data.permission)
    },

    logout(state, parameter = {}) {
        let pathUrl = ''
        if (state.userMsg && state.userMsg.user_source && state.userMsg.user_source === 'party_a') {
            pathUrl = '/partyALogin'
        } else {
            pathUrl = '/login'
        }
        state.userMsg = null
        state.token = null
        state.permission = []
        storage.remove('userMsg')
        storage.remove('token')
        storage.remove('permission')
        storage.remove('user_source')
        if (!parameter.login) {
            parameter.path = pathUrl
            router.push(parameter)
        }
    }

})

// /*** actions ***/
let actions = action(state, {
    setUserMsg({ commit }, res) {
        commit('setUserMsg', res)
    },

    logout({ commit }, parameter) {
        commit('logout', parameter)
    },

    pageLoading({ commit }, loading) {
        state.isLoading = loading
    }
})

// /*** module store ***/
let store = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

// /*** exports ***/
export let types = getTypes(store)
export let module = getModule(storeName)
export let Store = getStore(module, types)

export default store



// WEBPACK FOOTER //
// ./src/store/modules/user.js